import { AuthState } from '@okta/okta-auth-js';

export const isUserAdmin = (authState: AuthState | null): boolean => {
    if (!authState || !authState.isAuthenticated) return false;

    try {
        let groups: string[] = (authState.accessToken?.claims?.groups as string[]) || [];

        if (groups.length === 0 && authState.accessToken?.accessToken) {
            const token = authState.accessToken.accessToken;
            const tokenParts = token.split('.');
            if (tokenParts.length >= 2) {
                const base64Url = tokenParts[1];
                const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));
                
                const payload = JSON.parse(jsonPayload);
                groups = payload.groups || [];
            }
        }

        return groups.some((group: string) => group.toLowerCase().includes('admin'));
    } catch (error) {
        console.error("Error parsing user roles from token in frontend:", error);
        return false;
    }
};